// @flow

import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

type Props = { fqdn: string };

export function TransferButton({ fqdn }: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Button to={`/domain/transfer?search=${fqdn}`}>{__('Transfer')}</Button>
  );
}
